'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import Image from 'next/image';
import { FormatedLink } from '@/shared/formatUrl';
import UIButton from '@/components/atoms/UIButtons/UIButton';
import IsolatedBalloons from 'assets/images/Isolated_Balloons.png';
import patronLevelColorCode from './PatronLevelColorCode';
function getContrastColor(bgHex) {
  if (!bgHex) return '#000000';
  const hex = bgHex.replace('#', '');
  const r = parseInt(hex.substring(0, 2), 16) / 255;
  const g = parseInt(hex.substring(2, 4), 16) / 255;
  const b = parseInt(hex.substring(4, 6), 16) / 255;
  const srgb = [r, g, b].map(c => c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4));
  const L = 0.2126 * srgb[0] + 0.7152 * srgb[1] + 0.0722 * srgb[2];
  const contrastWhite = 1.05 / (L + 0.05);
  const contrastBlack = (L + 0.05) / 0.05;

  // 👇 small text safe rule
  if (contrastWhite >= 4.5) return '#FFFFFF';
  if (contrastBlack >= 4.5) return '#000000';

  // fallback (still choose better one)
  return contrastWhite > contrastBlack ? '#FFFFFF' : '#000000';
}
export default function PatronPartnersSection(t0) {
  const $ = _c(21);
  const {
    patrons: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const patrons = t2;
  const [columns, setColumns] = useState(2);
  const [items, setItems] = useState(patrons);
  let t3;
  let t4;
  if ($[2] !== patrons) {
    t3 = () => {
      const handleResize = () => {
        const w = window.innerWidth;
        const cols = w >= 1536 ? 5 : w >= 1024 ? 4 : w >= 640 ? 3 : 2;
        setColumns(cols);
        const isMobile = w < 640;
        setItems(isMobile ? [...patrons] : [...patrons, {
          type: "cta"
        }]);
      };
      handleResize();
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    };
    t4 = [patrons];
    $[2] = patrons;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  useEffect(t3, t4);
  if (!patrons || patrons.length === 0) {
    return null;
  }
  const totalItems = items.length;
  const totalRows = Math.ceil(totalItems / columns);
  let t5;
  if ($[5] !== columns || $[6] !== totalItems || $[7] !== totalRows) {
    t5 = index => {
      const row = Math.floor(index / columns) + 1;
      const col = index % columns + 1;
      const isFirstRow = row === 1;
      const isLastRow = row === totalRows;
      const lastColInRow = row === totalRows ? totalItems - (totalRows - 1) * columns : columns;
      const isFirstCol = col === 1;
      const isLastCol = col === lastColInRow;
      return [isFirstRow && isFirstCol && "xl:rounded-tl-[20px] lg:rounded-tl-[16px] rounded-tl-[12px]", isFirstRow && isLastCol && "xl:rounded-tr-[20px] lg:rounded-tr-[16px] rounded-tr-[12px]", isLastRow && isFirstCol && "xl:rounded-bl-[20px] lg:rounded-bl-[16px] rounded-bl-[12px]", isLastRow && isLastCol && "xl:rounded-br-[20px] lg:rounded-br-[16px] rounded-br-[12px]"].filter(Boolean).join(" ");
    };
    $[5] = columns;
    $[6] = totalItems;
    $[7] = totalRows;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const getRadiusClasses = t5;
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Image src={IsolatedBalloons} aria-hidden="true" alt="" className="absolute 2xl:-top-42.5 xl:top-[-7.25vw] lg:top-[-8vw] sm:top-[-15vw] top-[-33vw] right-0 z-[-1] max-w-[23.2vw] min-w-[200px]" />;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <h2 className="md:text-center xl:text-[54px] lg:text-[48px] sm:text-[40px] text-[26px] leading-[1em] font-semibold text-[#323232] 2xl:mb-10.5 lg:mb-8 md:mb-6 mb-5 md:max-w-none max-w-[50%]">Patron Partners</h2>;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== getRadiusClasses || $[12] !== items) {
    let t9;
    if ($[14] !== getRadiusClasses) {
      t9 = (item, index_0) => {
        const radiusClasses = getRadiusClasses(index_0);
        if (item.type === "cta") {
          return <div key="cta" className={`relative hidden sm:flex 2xl:h-[300px] xl:h-[270px] lg:h-[240px] md:h-[210px] h-[180px] border border-[#DDDDDD] -ml-0.25 -mb-0.25 2xl:py-9 xl:py-6 py-5 2xl:px-8 xl:px-6 px-4 flex-wrap bg-white ${radiusClasses}`}><h3 className="mb-3 2xl:text-2xl xl:text-xl lg:text-lg text-base font-semibold leading-[1.16] text-[#323232]">Interested in<br />Becoming a<br />Patron Partner?</h3><UIButton variant="gradient" href="mailto:hello@theparadeofhearts.com" className="text-sm font-semibold justify-center !w-full mt-auto !max-w-full">Contact Us</UIButton></div>;
        }
        const hasUrl = Boolean(item?.patronUrl);
        const levelTitle = item?.patronLevel?.title || "Patron";
        const levelColor = patronLevelColorCode[levelTitle] || "#323232";
        const textColor = getContrastColor(levelColor);
        return <div key={item?.id ?? index_0} className={`relative flex 2xl:h-[300px] xl:h-[270px] lg:h-[240px] md:h-[210px] h-[180px] border border-[#DDDDDD] -ml-0.25 -mb-0.25 sm:py-12 sm:px-8 py-9 px-6 flex-col items-center justify-center bg-white ${radiusClasses}`}><span className="absolute right-2.5 top-2.5 rounded-full lg:px-3 px-2 lg:py-1.5 py-0.5 lg:text-xs text-[10px] font-medium" style={{
            backgroundColor: levelColor,
            color: textColor
          }}>{levelTitle}</span>{hasUrl ? <FormatedLink href={item.patronUrl} className="block w-full h-full"><div className="relative w-full h-full lg:pt-2.5">{item?.media?.previewsrc && <Image src={item.media.previewsrc} alt={item?.title || "Patron logo"} width={164} height={164} className="object-contain w-full h-full" />}</div></FormatedLink> : <div className="relative w-full h-full opacity-60 pointer-events-none">{item?.media?.previewsrc && <Image src={item.media.previewsrc} alt={item?.title || "Patron logo"} width={164} height={164} className="object-contain w-full h-full" />}</div>}</div>;
      };
      $[14] = getRadiusClasses;
      $[15] = t9;
    } else {
      t9 = $[15];
    }
    t8 = items.sort(_temp).map(t9);
    $[11] = getRadiusClasses;
    $[12] = items;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[16] !== t8) {
    t9 = <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 2xl:grid-cols-5 sm:mx-0 -mx-4">{t8}</div>;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className="mt-10 flex justify-center md:hidden"><UIButton href="mailto:hello@theparadeofhearts.com" variant="default" className="rounded-full !px-4.75 py-3 text-sm font-semibold">Become a Patron</UIButton></div>;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t9) {
    t11 = <section id="patron-partners" className="relative section-spacing scroll-mt-20 md:scroll-mt-0 lg:mt-28 mt-35">{t6}<div className="container-wrap relative z-10">{t7}{t9}{t10}</div></section>;
    $[19] = t9;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  return t11;
}
function _temp(a, b) {
  return a.order - b.order;
}